import React from 'react';

const RetryIcon: React.FC<{ width?: number; height?: number; className?: string }> = ({
  width = 18,
  height = 18,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.95319 2.00003C7.25066 1.99494 5.60462 2.61052 4.32323 3.73153C3.04183 4.85254 2.2129 6.40213 1.99163 8.09023C1.91985 8.63784 1.41775 9.02357 0.870146 8.95179C0.322546 8.88001 -0.0631841 8.3779 0.00859443 7.8303C0.293089 5.65989 1.35884 3.66755 3.00636 2.22625C4.65387 0.78495 6.7702 -0.00650491 8.95917 4.02729e-05C11.1481 0.00658546 13.2597 0.810682 14.8986 2.26181C16.5374 3.71293 17.5912 5.71161 17.8628 7.88369C18.1343 10.0558 17.6049 12.2523 16.3736 14.0622C15.1424 15.8721 13.2937 17.1712 11.1737 17.7164C9.05371 18.2616 6.80768 18.0154 4.85608 17.024C3.74892 16.4616 2.77957 15.6812 2.00011 14.7398V16.9603C2.00011 17.5126 1.5524 17.9603 1.00011 17.9603C0.447828 17.9603 0.000112812 17.5126 0.000112812 16.9603V11.9603C0.000112812 11.408 0.447828 10.9603 1.00011 10.9603H1.47683C1.49218 10.9599 1.50751 10.9599 1.5228 10.9603H6.00011C6.5524 10.9603 7.00011 11.408 7.00011 11.9603C7.00011 12.5126 6.5524 12.9603 6.00011 12.9603H3.16022C3.81838 13.9195 4.71019 14.7066 5.7619 15.2409C7.27981 16.012 9.02672 16.2035 10.6756 15.7794C12.3245 15.3554 13.7624 14.345 14.72 12.9373C15.6776 11.5296 16.0894 9.82115 15.8782 8.13176C15.667 6.44236 14.8474 4.88784 13.5727 3.75918C12.298 2.63053 10.6557 2.00512 8.95319 2.00003Z"
      fill="currentColor"
    />
  </svg>
);

export default RetryIcon;
